import { boot } from 'quasar/wrappers'
import AutoFocus from '../directives/AutoFocus'
import Percent from '../directives/Percent'
import Price from '../directives/Price'
import Number from '../directives/Number'

export default boot(({ app }) => {
  // We globally register our directive with Vue;
  // Rememeber that all directives in Vue will start with 'v-'
  // but that should not be part of your directive name
  // https://vuejs.org/v2/guide/custom-directive.html
  // 'auto-focus' will be used as 'v-auto-focus'
  app.directive('auto-focus', AutoFocus)
  app.directive('percent', Percent)
  app.directive('price', Price)
  app.directive('number', Number)
})
